import { Component, ElementRef, OnInit } from '@angular/core';
import { EContentGreeting, IContent } from '../../store/models/content.model';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Button, ButtonColor, ButtonSize } from '../../store/models/button.model';
import { ISelect } from '../../store/models/select.model';
import { ActivatedRoute, Router } from '@angular/router';
import { ContentService } from '../../store/services/content.service';
import { Store } from '@ngrx/store';
import { IReducers } from '../../store/reducers';
import { openDialog, openSnackbar } from '../../store/actions/page.action';
import { InsertHyperlinkComponent } from '../../dialogs/insert-hyperlink/insert-hyperlink.component';
import { DialogComponent } from '../../shared/ui/dialog/dialog.component';
import { forkJoin, Observable } from 'rxjs';

@Component({
  selector: 'app-edit-master-content',
  templateUrl: './edit-master-content.component.html',
  styleUrls: ['./edit-master-content.component.scss'],
})
export class EditMasterContentComponent implements OnInit {
  contentId: number;
  contentGroupId: number;
  index: number;
  contentInfo: IContent;

  formGroup: FormGroup;

  cancelButtonProperties: Button = {
    text: 'Back',
    color: ButtonColor.WHITE,
    onClick: () => {
      this.router.navigate([
        '/contents',
        'preview-master-content',
        this.contentGroupId,
      ]);
    },
    size: ButtonSize.SMALL,
  };
  greetings: ISelect<any> = {
    label: 'Select greeting',
    items: [
      {
        label: EContentGreeting.HI_FIRST_NAME,
        value: EContentGreeting.HI_FIRST_NAME,
      },
      {
        label: EContentGreeting.FIRST_NAME,
        value: EContentGreeting.FIRST_NAME,
      },
      {
        label: EContentGreeting.ALOHA,
        value: EContentGreeting.ALOHA,
      },
      {
        label: EContentGreeting.NEW,
        value: 'new',
      },
    ],
  };
  showCustomGreeting: boolean;
  submitButtonProperties: Button = {
    color: ButtonColor.ORANGE,
    text: 'Apply',
    size: ButtonSize.SMALL,
    onClick: () => {
      if (this.formGroup.valid) {
        const content = Object.assign({}, this.contentInfo);

        content.content_attention = this.formGroup.get('attention').value;
        content.content_closing = this.formGroup.get('closing').value;
        content.content_details = this.formGroup.get('details').value;
        content.content_opening = this.formGroup.get('opening').value;
        content.greeting = this.showCustomGreeting
          ? this.formGroup.get('custom_greeting').value
          : this.formGroup.get('greeting').value;
        content.subject = this.formGroup.get('subject').value;
        content.first_benefit = this.formGroup.get('benefit_01').value;
        content.second_benefit = this.formGroup.get('benefit_02').value;

        this.contentService
          .updateContent(this.contentId, content)
          .subscribe(result => {
            if (result && result.content_id) {
              this.router.navigate([
                `/contents', 'preview-master-content`,
                this.contentGroupId,
              ], {
                queryParams: {
                  index: this.contentInfo.content_template.replace('email_template', ''),
                },
              });
            }
          });
      }
    },
  };
  private backToGreetingClicked: boolean;
  backToGreetingsButton: Button = {
    text: 'Back to greetings',
    color: ButtonColor.WHITE,
    size: ButtonSize.SMALL,
    onClick: () => {
      this.formGroup.get('custom_greeting').setValue('');
      this.formGroup.get('custom_greeting').enable();
      this.showCustomGreeting = false;
      this.backToGreetingClicked = true;
    },
  };

  constructor(
    private activatedRoute: ActivatedRoute,
    private contentService: ContentService,
    private store: Store<IReducers>,
    private router: Router,
  ) {
  }

  onGreetingsSelection = (value: string) => {
    if (value === 'new') {
      this.showCustomGreeting = true;
      this.backToGreetingClicked = false;
    } else {
      this.formGroup.get('greeting').setValue(value);
    }
  };

  ngOnInit() {
    this.contentId = this.activatedRoute.snapshot.params.templateId;
    this.contentGroupId = this.activatedRoute.snapshot.params.groupId;
    this.index = this.activatedRoute.snapshot.queryParams.index;
    this.cancelButtonProperties.onClick = () =>
      this.router.navigate([
        '/contents',
        'preview-master-content',
        this.contentGroupId,
      ], {
        queryParams: {
          index: this.contentInfo.content_template.replace('email_template', ''),
        },
      });
    this.submitButtonProperties.onClick = () => {
      if (this.formGroup.valid) {
        const content = Object.assign({}, this.contentInfo);
        let doAll = false;
        content.content_attention = this.formGroup.get('attention').value;
        content.content_closing = this.formGroup.get('closing').value;
        content.content_details = this.formGroup.get('details').value;
        // content.content_opening = this.formGroup.get('opening').value;
        content.greeting = this.showCustomGreeting
          ? this.formGroup.get('custom_greeting').value +
          (!this.backToGreetingClicked ? ' {first_name},' : '')
          : this.formGroup.get('greeting').value;
        content.subject = this.formGroup.get('subject').value;
        content.first_benefit = this.formGroup.get('benefit_01').value;
        content.second_benefit = this.formGroup.get('benefit_02').value;
        content.content_opening = this.formGroup.get('opening').value;

        if (
          this.formGroup.get('apply_attention').value === true ||
          this.formGroup.get('apply_benefit_01').value === true ||
          this.formGroup.get('apply_benefit_02').value === true ||
          this.formGroup.get('apply_closing').value === true ||
          this.formGroup.get('apply_details').value === true ||
          this.formGroup.get('apply_subject').value === true ||
          this.formGroup.get('apply_opening').value === true
        ) {
          doAll = true;
        }

        if (doAll) {
          this.contentService
            .getContentsByGroupId(this.contentGroupId)
            .subscribe(response => {
              const items: IContent[] = response;

              const subscriptions: Observable<any>[] = [];

              for (const item of items) {
                if (item.content_id !== Number(this.contentId)) {
                  const contentAll = Object.assign({}, item);

                  if (this.formGroup.get('apply_attention').value === true) {
                    contentAll.content_attention =
                      this.formGroup.get('attention').value;
                  }

                  if (this.formGroup.get('apply_benefit_01').value === true) {
                    contentAll.first_benefit =
                      this.formGroup.get('benefit_01').value;
                  }

                  if (this.formGroup.get('apply_benefit_02').value === true) {
                    contentAll.second_benefit =
                      this.formGroup.get('benefit_02').value;
                  }

                  if (this.formGroup.get('apply_closing').value === true) {
                    contentAll.content_closing =
                      this.formGroup.get('closing').value;
                  }

                  if (this.formGroup.get('apply_details').value === true) {
                    contentAll.content_details =
                      this.formGroup.get('details').value;
                  }

                  if (this.formGroup.get('apply_subject').value === true) {
                    contentAll.subject = this.formGroup.get('subject').value;
                  }

                  if (this.formGroup.get('apply_opening').value === true) {
                    contentAll.content_opening = this.formGroup.get('opening').value;
                  }

                  subscriptions.push(
                    this.contentService.updateContent(
                      item.content_id,
                      contentAll,
                    ),
                  );
                } else {
                  subscriptions.push(
                    this.contentService.updateContent(this.contentId, content),
                  );
                }
              }

              if (subscriptions.length) {
                forkJoin(subscriptions).subscribe(
                  () =>
                    this.router.navigate([
                      '/contents',
                      'preview-master-content',
                      this.contentGroupId,
                    ]),
                  () =>
                    this.store.dispatch(
                      openSnackbar({
                        snackbarData: {
                          data: {
                            message: 'There was an error updating the content',
                            type: 'error',
                          },
                        },
                      }),
                    ),
                  () =>
                    this.router.navigate([
                      '/contents',
                      'preview-master-content',
                      this.contentGroupId,
                    ]),
                );
              }
            });
        } else {
          this.contentService
            .updateContent(this.contentId, content)
            .subscribe(result => {
              if (result && result.content_id) {
                this.router.navigate([
                  '/contents',
                  'preview-master-content',
                  this.contentGroupId,
                ], {
                  queryParams: {
                    index: this.contentInfo.content_template.replace('email_template', ''),
                  },
                });
              }
            });
        }
      } else {
        this.formGroup.markAllAsTouched();
        window.scroll({
          top: 0,
          behavior: 'smooth',
        });
      }
    };

    this.contentService
      .getContentInfo(this.contentId)
      .subscribe((result: IContent) => {
        this.formGroup = new FormGroup({
          subject: new FormControl(result.subject, [Validators.required]),
          apply_subject: new FormControl(false),
          custom_greeting: new FormControl(),
          greeting: new FormControl(result.greeting),
          attention: new FormControl(result.content_attention),
          apply_attention: new FormControl(false),
          benefit_01: new FormControl(result.first_benefit),
          apply_benefit_01: new FormControl(false),
          benefit_02: new FormControl(result.second_benefit),
          apply_benefit_02: new FormControl(false),
          closing: new FormControl(result.content_closing),
          apply_closing: new FormControl(false),
          details: new FormControl(result.content_details),
          apply_details: new FormControl(false),
          opening: new FormControl(result.content_opening),
          apply_opening: new FormControl(false),
        });

        if (result.greeting) {
          if (
            [
              EContentGreeting.FIRST_NAME,
              EContentGreeting.HI_FIRST_NAME,
              EContentGreeting.ALOHA,
            ].indexOf(result.greeting) === -1
          ) {
            this.showCustomGreeting = true;
            this.formGroup.get('custom_greeting').disable();
            this.formGroup.get('custom_greeting').setValue(result.greeting);
          } else {
            this.formGroup.get('greeting').setValue(result.greeting);
          }
        }

        this.contentInfo = result;
      });
  }

  insertHyperlink(controlName: string) {
    this.store.dispatch(
      openDialog({
        dialogData: {
          content: InsertHyperlinkComponent,
          title: 'Insert Hyperlink',
          canClose: true,
          dialogMinWidth: '700px',
          buttons: [
            {
              color: ButtonColor.BLUE,
              size: ButtonSize.SMALL,
              text: 'Insert Link',
              actAsClose: true,
              onClick: (dialog: DialogComponent) => {
                if (dialog.dialogForm.valid) {
                  const anchor = `<a href='${
                    dialog.dialogForm.get('url').value
                  }' target='${dialog.dialogForm.get('target').value}'>${
                    dialog.dialogForm.get('content').value
                  }</a>`;
                  this.insertLink(anchor, controlName);
                }
              },
            },
          ],
        },
      }),
    );
  }

  private insertLink(linkContent: string, controlName: string) {
    const elementRef: ElementRef = this[controlName];

    if (!elementRef) {
      return false;
    }

    const cursorPosition = elementRef.nativeElement.selectionStart;
    const prevValue = this.formGroup.get(controlName).value;
    const leftString = prevValue.substr(0, cursorPosition);
    const rightString = prevValue.substr(cursorPosition);

    this.formGroup
      .get(controlName)
      .setValue(leftString + linkContent + rightString);
  }
}
